import ItemDetails, { Record } from "./Item-details";

export default ItemDetails;

export { Record };
